// extracted by mini-css-extract-plugin
export default {"table":"Help_table__Rn9sr","row":"Help_row__F1OnR","header":"Help_header__4dqEf","cell":"Help_cell__H14SR","title":"Help_title__lAJsO","msg":"Help_msg__vclMI"};